module.exports = __webpack_public_path__ + "img/arrow_back_black.9467b21d.svg";